import React from 'react';
import { BsTwitter, BsInstagram, BsLinkedin } from 'react-icons/bs';

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="https://twitter.com/saielhaq" target='_blank'><BsTwitter /></a>
    </div>
    <div>
      <a href="https://linkedin.com/in/saielhaqs" target='_blank'><BsLinkedin /></a>
    </div>
    <div>
      <a href="https://instagram.com/saielhaqs" target='_blank'><BsInstagram /></a>
    </div>
  </div>
);

export default SocialMedia;